export default {"src":"/_next/static/media/fire_24.1932976b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};